<template>
  <div class="avatar">
    <el-dropdown class="avatar-dropdown" style="cursor: pointer;" placement="bottom">
      <div class="el-dropdown-link">
        <span>{{ users.userName }}</span>
        <i class="el-icon-arrow-down el-icon--right"></i>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item><span
            @click="modifyPassword">修改密码</span></el-dropdown-item>
        <el-dropdown-item divided style="color: #f56c6b !important;">
          <span @click="logout">退出登录</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: 'Avatar',
  components: {},
  data() {
    return {
      api: this.$store.state.api,
      users: this.$store.state.users,
    }
  },
  methods: {
    modifyPassword() {
      top.postMessage(
          {
            handlerType: 'modifyPassword',
          },
          '*'
      )
    },
    logout() {
      this.$system.post(this.api + '/systematic/userLogout-1', {}, true, true, this.toLogin, this.toLogin)
    },
    toLogin() {
      this.$zwxCookie.delCookie('msTokenId')
      this.$zwxCookie.delCookie('userRole')
      window.localStorage.removeItem('loginState')
      this.$router.push({path: '/login'})
    },
  },
}
</script>

<style lang="less" scoped>
.avatar-dropdown {
  float: right;
  position: relative;
  line-height: 22px;
  margin-right: 26px;

  .el-dropdown-link {
    font-size: 14px;
    color: #3a485e;
    font-weight: 400;
  }

  .svg-img {
    float: left;
    height: 22px;
    width: 22px;
    margin-right: 8px;
    border-radius: 50%;
  }
}

.el-dropdown {
  color: #3a485e;
}

.el-dropdown-menu {
  user-select: none;
  padding: 0 20px;
  margin: 4px 0;
}

.el-dropdown-menu__item {
  padding: 0;
  line-height: 43px;
  font-size: 13px;
  font-weight: 400;
  background: 0 0 !important;
  color: #1f2d3d !important;
}

.el-dropdown-menu__item--divided {
  border-top: 1px solid #3a485e;
  margin-top: 0;
}

.el-dropdown-menu__item span {
  display: block;
  height: 43px;
}

.el-dropdown-menu__item--divided:before {
  height: 1px;
}

.el-icon--right {
  margin-left: 8px;
  font-size: 12px;
}

.el-icon--right:before {
  content: '\e6df' !important;
  color: #3a485e;
}
</style>


